import { Connector } from '../common/redux/api/web-api'

export const isLeftConnector = (connectorId?: number) => connectorId === 1

// TODO: Add typing for [connectors]
const findLeftConnector = (connectors: Connector[]): Connector | null => {
    if (!connectors || !connectors.length) return null
    return connectors.find((connector) => isLeftConnector(connector.connectorId)) || null
}

export default findLeftConnector
